import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { PATH } from '../../constants/router'
import { useAppUserContext } from '../../context/AppUserContext'
import { useAppParamsContext } from '../../context/AppParamsContext'
import LoadingScreen from '../../components/BasicComponent/LoadingScreen'
import LayoutPartner from '../../components/BasicComponent/LayoutPartner'
import './index.scss'

export default function BIDVLogin() {
  const history = useHistory()
  const location = useLocation()
  const { confirmSdkTokenData } = useAppUserContext()
  const { isHeaderMiniApp } = useAppParamsContext()
  const [hasError, setHasError] = useState(false)

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search)
    const sdkToken = searchParams.get('sdkToken')

    if (sdkToken) {
      confirmSdkTokenData(sdkToken)
      history.replace(PATH.TRAFFIC_FINE_LOOKUP)
    } else {
      setHasError(true)
    }
  }, [history, location.search, confirmSdkTokenData])

  if (hasError) {
    return (
      <LayoutPartner noHeader={!isHeaderMiniApp} blendHeaderWithBody>
        <div className="BIDVLogin_errorText">Tải dữ liệu thất bại.</div>
      </LayoutPartner>
    )
  }

  return <LoadingScreen open={true} />
}
